(function(){
  var money = function(cents){ return '\u20AC' + (cents/100).toFixed(2).replace('.', ','); };
  var $ = function(s,r){ return (r||document).querySelector(s); };
  var $$ = function(s,r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };

  /* ---------- mobiel menu ---------- */
  document.addEventListener('click', function(e){
    var open = e.target.closest('[data-menu-open]');
    var close = e.target.closest('[data-menu-close]');
    if (open) { $('#MobileMenu').classList.add('is-open'); document.body.style.overflow='hidden'; }
    if (close) { $('#MobileMenu').classList.remove('is-open'); document.body.style.overflow=''; }
  });

  /* ---------- cart drawer ---------- */
  function openCart(){ document.body.classList.add('drawer-open'); }
  function closeCart(){ document.body.classList.remove('drawer-open'); }

  function renderCart(cart){
    var count = cart.item_count;
    $$('[data-cart-count]').forEach(function(el){
      el.textContent = count;
      el.setAttribute('data-filled', count > 0 ? 'true' : 'false');
    });
    var body = $('[data-cart-body]');
    if (!body) return;
    if (!count) {
      body.innerHTML = $('#CartEmptyTemplate').innerHTML;
      $('[data-cart-foot]').hidden = true;
      $('[data-cart-note]').hidden = true;
      return;
    }
    $('[data-cart-foot]').hidden = false;
    $('[data-cart-note]').hidden = false;
    var html = cart.items.map(function(it){
      return '<div class="line">' +
        '<img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '') + '" alt="' + it.product_title + '" loading="lazy" width="68" height="68">' +
        '<div style="flex:1;min-width:0;display:flex;flex-direction:column;gap:4px">' +
          '<span class="line__name">' + it.product_title + '</span>' +
          '<span class="line__meta">' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '') + '</span>' +
          '<div class="row gap-10" style="margin-top:4px">' +
            '<div class="qty qty--sm"><button type="button" data-line-change="' + it.key + '" data-qty="' + (it.quantity - 1) + '" aria-label="Minder">\u2212</button>' +
            '<input type="text" value="' + it.quantity + '" readonly aria-label="Aantal">' +
            '<button type="button" data-line-change="' + it.key + '" data-qty="' + (it.quantity + 1) + '" aria-label="Meer">+</button></div>' +
            '<button type="button" class="small" style="text-decoration:underline" data-line-change="' + it.key + '" data-qty="0">Verwijder</button>' +
          '</div>' +
        '</div>' +
        '<span class="line__price">' + money(it.final_line_price) + '</span>' +
      '</div>';
    }).join('');
    var upsell = $('#CartUpsellTemplate');
    if (upsell) {
      var upsellId = upsell.getAttribute('data-upsell-id');
      var alreadyIn = cart.items.some(function(i){ return String(i.product_id) === String(upsellId); });
      if (!alreadyIn) html += upsell.innerHTML;
    }
    body.innerHTML = html;
    $('[data-cart-total]').textContent = money(cart.total_price);
  }

  function fetchCart(){ return fetch('/cart.js').then(function(r){ return r.json(); }).then(renderCart); }

  function addToCart(items){
    return fetch('/cart/add.js', {
      method: 'POST', headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ items: items })
    }).then(function(r){ return r.json(); }).then(function(){ return fetchCart(); }).then(openCart);
  }

  document.addEventListener('click', function(e){
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); fetchCart(); }
    if (e.target.closest('[data-cart-close]')) { closeCart(); }
    var chg = e.target.closest('[data-line-change]');
    if (chg) {
      fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ id: chg.getAttribute('data-line-change'), quantity: parseInt(chg.getAttribute('data-qty'),10) })
      }).then(function(r){ return r.json(); }).then(renderCart);
    }
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      var label = quick.textContent;
      quick.textContent = 'Toegevoegd';
      quick.disabled = true;
      addToCart([{ id: quick.getAttribute('data-quick-add'), quantity: 1 }]).then(function(){
        setTimeout(function(){ quick.textContent = label; quick.disabled = false; }, 1200);
      });
    }
  });

  /* ---------- productformulier met add-ons ---------- */
  var form = $('[data-product-form]');
  if (form) {
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var items = [{ id: form.querySelector('[name="id"]').value, quantity: parseInt(form.querySelector('[name="quantity"]').value || '1', 10) }];
      $$('.addon[aria-pressed="true"]', document).forEach(function(a){
        if (a.getAttribute('data-variant')) items.push({ id: a.getAttribute('data-variant'), quantity: 1 });
      });
      addToCart(items);
    });
  }
  document.addEventListener('click', function(e){
    var addon = e.target.closest('.addon');
    if (addon) { addon.setAttribute('aria-pressed', addon.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); }
    var q = e.target.closest('[data-qty-step]');
    if (q) {
      var input = q.parentElement.querySelector('input');
      var v = parseInt(input.value, 10) + parseInt(q.getAttribute('data-qty-step'), 10);
      input.value = Math.max(1, v);
    }
  });

  /* ---------- maatkiezer ---------- */
  (function(){
    var picker = $('[data-variant-picker]');
    if (!picker) return;
    var hidden = $('[data-product-form] [name="id"]');
    var priceEl = $('[data-price]');
    var noteEl = $('[data-variant-note]');
    var sel = $('[data-variant-select]');

    function choose(id, price){
      if (hidden) hidden.value = id;
      if (priceEl && price) priceEl.textContent = price;
      $$('[data-variant-id]').forEach(function(b){ b.setAttribute('aria-pressed', b.getAttribute('data-variant-id') === String(id) ? 'true' : 'false'); });
      if (sel) sel.value = id;
      var sticky = $('.sticky-buy [data-quick-add]');
      if (sticky) sticky.setAttribute('data-quick-add', id);
      if (noteEl) {
        var btn = $$('[data-variant-id]').filter(function(b){ return b.getAttribute('data-variant-id') === String(id); })[0];
        var note = btn && btn.querySelector('.variant__note');
        noteEl.textContent = note ? note.textContent.trim() : '';
        noteEl.hidden = !note;
      }
      var url = new URL(window.location);
      url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url);
    }

    picker.addEventListener('click', function(e){
      var b = e.target.closest('[data-variant-id]');
      if (b && !b.disabled) choose(b.getAttribute('data-variant-id'), b.getAttribute('data-variant-price'));
    });
    if (sel) sel.addEventListener('change', function(){
      var opt = sel.options[sel.selectedIndex];
      choose(sel.value, opt.getAttribute('data-variant-price'));
    });
  })();

  /* ---------- galerij + lightbox ---------- */
  var main = $('[data-gallery-main]');
  if (main) {
    var srcs = $$('[data-gallery-thumb]').map(function(t){ return t.getAttribute('data-full'); });
    var idx = 0;
    function show(i){
      idx = (i + srcs.length) % srcs.length;
      main.src = srcs[idx];
      var lb = $('[data-lightbox-img]'); if (lb) lb.src = srcs[idx];
      $$('[data-gallery-thumb]').forEach(function(t, n){ t.setAttribute('aria-current', n === idx ? 'true' : 'false'); });
      $$('[data-dot]').forEach(function(d, n){ if (n === idx) { d.setAttribute('data-active','true'); } else { d.removeAttribute('data-active'); } });
      var c = $('[data-lightbox-count]'); if (c) c.textContent = 'Foto ' + (idx + 1) + ' van ' + srcs.length;
    }
    var swipe = $('[data-gallery-swipe]');
    if (swipe) {
      var tick;
      swipe.addEventListener('scroll', function(){
        clearTimeout(tick);
        tick = setTimeout(function(){
          var i = Math.round(swipe.scrollLeft / swipe.clientWidth);
          if (i !== idx) show(i);
        }, 60);
      }, { passive: true });
    }
    document.addEventListener('click', function(e){
      var sw = e.target.closest('[data-swipe-index]');
      if (sw) { show(parseInt(sw.getAttribute('data-swipe-index'), 10)); $('.lightbox').classList.add('is-open'); document.body.style.overflow='hidden'; return; }
      var t = e.target.closest('[data-gallery-thumb]');
      if (t) show($$('[data-gallery-thumb]').indexOf(t));
      if (e.target.closest('[data-lightbox-open]')) { $('.lightbox').classList.add('is-open'); show(idx); document.body.style.overflow='hidden'; }
      if (e.target.closest('[data-lightbox-close]')) { $('.lightbox').classList.remove('is-open'); document.body.style.overflow=''; }
      if (e.target.closest('[data-lightbox-prev]')) show(idx - 1);
      if (e.target.closest('[data-lightbox-next]')) show(idx + 1);
    });
    document.addEventListener('keydown', function(e){
      if (!$('.lightbox') || !$('.lightbox').classList.contains('is-open')) return;
      if (e.key === 'Escape') { $('.lightbox').classList.remove('is-open'); document.body.style.overflow=''; }
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
  }

  /* ---------- bezorgbelofte ---------- */
  $$('[data-ship-promise]').forEach(function(el){
    var cutoff = parseInt(el.getAttribute('data-cutoff') || '15', 10);
    var D = ['zondag','maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag'];
    var M = ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'];
    var now = new Date();
    var work = function(d){ return d.getDay() >= 1 && d.getDay() <= 5; };
    var before = work(now) && now.getHours() < cutoff;
    var ship = new Date(now);
    if (!before) { do { ship.setDate(ship.getDate() + 1); } while (!work(ship)); }
    var del = new Date(ship);
    do { del.setDate(del.getDate() + 1); } while (!work(del));
    var tom = new Date(now); tom.setDate(tom.getDate() + 1);
    var dateStr = D[del.getDay()] + ' ' + del.getDate() + ' ' + M[del.getMonth()];
    var left = '';
    if (before) {
      var cut = new Date(now); cut.setHours(cutoff, 0, 0, 0);
      var mins = Math.max(1, Math.round((cut - now) / 60000));
      var h = Math.floor(mins / 60), m = mins % 60;
      left = h > 0 ? h + ' uur ' + m + ' min' : m + ' min';
    }
    var shipDay = ship.toDateString() === tom.toDateString() ? 'morgen' : D[ship.getDay()] + ' ' + ship.getDate() + ' ' + M[ship.getMonth()];
    var t = el.querySelector('[data-ship-title]'), s = el.querySelector('[data-ship-sub]');
    if (t) t.textContent = before ? 'Bestel binnen ' + left + ' en het gaat vandaag nog op de post' : 'Wordt ' + shipDay + ' verzonden';
  });

  /* ---------- plankkiezer ---------- */
  $$('[data-chooser]').forEach(function(root){
    root.addEventListener('click', function(e){
      var b = e.target.closest('[data-rec]');
      if (!b) return;
      var active = b.getAttribute('aria-pressed') === 'true';
      $$('[data-rec]', root).forEach(function(x){ x.setAttribute('aria-pressed','false'); });
      var rec = active ? '' : b.getAttribute('data-rec');
      b.setAttribute('aria-pressed', active ? 'false' : 'true');
      $$('[data-col]', root).forEach(function(c){ c.classList.toggle('is-rec', !!rec && c.getAttribute('data-col') === rec); });
      var box = $('[data-rec-out]', root);
      if (box) {
        box.hidden = !rec;
        if (rec) {
          box.querySelector('[data-rec-text]').textContent = b.getAttribute('data-rec-text');
          var link = box.querySelector('a');
          link.href = b.getAttribute('data-rec-url');
          link.textContent = b.getAttribute('data-rec-cta');
        }
      }
    });
  });

  /* ---------- zakelijke routes ---------- */
  $$('[data-tracks]').forEach(function(root){
    root.addEventListener('click', function(e){
      var b = e.target.closest('[data-track]');
      if (!b) return;
      var key = b.getAttribute('data-track');
      $$('[data-track]', root).forEach(function(x){
        var on = x === b;
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
        var cta = x.querySelector('.track-card__cta');
        if (cta) cta.textContent = on ? 'Je kijkt hiernaar' : 'Bekijk deze route';
      });
      $$('[data-track-panel]').forEach(function(p){ p.hidden = p.getAttribute('data-track-panel') !== key; });
    });
  });

  fetchCart();
})();
